import axios from 'axios'
export const state = {
    siteList: {},
}

export const getters = {}

export const mutations = {
    CACHE_SITE_LIST(state, newList) {
        state.siteList = newList
    },
}

export const actions = {
    fetchSiteList({ commit, state, rootState }) {
        return axios
            .get(
                `${process.env.VUE_APP_API_BASE_URL}/site-config/all`
            )
            .then((response) => {
                const data = response.data
                // const list = {}
                // data.forEach((element) => {
                //     list[element.platform_id] = element.site_name
                // })
                // commit('CACHE_SITE_LIST', list)
                return data
            })
    },
}
